    <template>
      <div class="card mb-25 border-0 rounded-0 bg-white add-matiere-card">
        <div class="card-header">
          <h3 class="text-black fw-semibold">Ajouter un professeur</h3>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="professeurForm" @submit="addProfesseur" :validation-schema="professeurSchema">
            <div class="row">

              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom du professeur <span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le nom" />
                  <ErrorMessage name="nom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Prénom du professeur<span class="text-danger">*</span>
                  </label>
                  <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le prenom" />
                  <ErrorMessage name="prenom" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Numéro NPI 
                  </label>
                  <Field name="npi" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le numéro" />
                  <ErrorMessage name="npi" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    IFU 
                  </label>
                  <Field name="ifu" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer l'ifu" />
                  <ErrorMessage name="ifu" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Email <span class="text-danger">*</span>
                  </label>
                  <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer l'email" />
                  <ErrorMessage name="email" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Sexe <span class="text-danger">*</span>
                  </label>
                  <Field name="sexe" type="text" v-slot="{ field }">
                    <Multiselect :searchable="true" :options="['Masculin', 'Féminin']" v-model="field.value"
                      v-bind="field" placeholder="Sélectionner le sexe" />
                  </Field>
                  <ErrorMessage name="sexe" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone 1 <span class="text-danger">*</span>
                  </label>
                  <Field name="telProfesseur1"  v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                      defaultCountry="BJ" mode="international" @validate="validate"
                      class="shadow-none fs-md-15 text-black py-2">
                    </vue-tel-input>
                  </Field>
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correcte</div>
                  <!-- <Field name="telProfesseur1" type="text" 
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le téléphone"/> -->
                  <ErrorMessage name="telProfesseur1" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone 2
                  </label>
                  <Field name="telProfesseur2" v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                      defaultCountry="BJ" mode="international" @validate="validate"
                      class="shadow-none fs-md-15 text-black py-2">
                    </vue-tel-input>
                  </Field>
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correcte</div>
                  <!-- <Field name="telProfesseur2" type="text" 
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le téléphone"/> -->
                  <ErrorMessage name="telProfesseur2" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de naissance 
                  </label>
                  <Field name="dateNaissance" type="date" :max="currentDate"
                    class="form-control shadow-none fs-md-15 text-black" />
                </div>
                <ErrorMessage name="dateNaissance" class="text-danger" />
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Pays de naissance
                    <span class="text-danger">*</span>
                  </label>
                  <Field name="nationalite" v-model="nationalite" v-slot="{ field }">
                    <Multiselect :options="countries" :searchable="true" track-by="value" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner le pays de résidence" />
                  </Field>

                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Commune <span class="text-danger">*</span>
                  </label>
                  <Field name="commune" v-model="commune" v-slot="{ field }">
                    <Multiselect :options="communeOptions" @change="communeChange($event)" :searchable="true"
                      track-by="label" label="label" v-model="selectedCommune" v-bind="field"
                      placeholder="Sélectionner la commune" />
                  </Field>
                  <ErrorMessage name="commune" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Quartier <span class="text-danger">*</span>
                  </label>
                  <Field name="quartier" v-model="quartier" v-slot="{ field }">
                    <Multiselect :options="quartierOptions" :searchable="true" track-by="label" label="label"
                      v-model="selectedQuartier" v-bind="field" noOptionsText="Sélectionner d'abord une commune"
                      placeholder="Sélectionner le quartier" />
                  </Field>
                  <ErrorMessage name="quartier" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="anneeExperience" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Nombre d'années d'expériences
                  </label>
                  <Field name="anneeExperience" type="number"  v-model="anneeExperience"
                    class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer le nombre" />
                  <ErrorMessage name="anneeExperience" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Matières <span class="text-danger">*</span>
                  </label>
                  <Field name="matieres" v-slot="{ field }">
                    <Multiselect :options="matieresOptions" :searchable="true" mode="tags" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner les matières" />
                  </Field>
                </div>
                <ErrorMessage name="matieres" class="text-danger" />
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Qualification <span class="text-danger">*</span>
                  </label>
                  <Field name="qualification" v-slot="{ field }">
                    <Multiselect :options="qualificationOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner la qualification" />
                  </Field>
                </div>
                <ErrorMessage name="qualification" class="text-danger" />
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Activité <span class="text-danger">*</span>
                  </label>
                  <Field name="activites" v-slot="{ field }">
                    <Multiselect :options="activiteOptions" :searchable="true" mode="tags" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner l'activité" />
                  </Field>
                </div>
                <ErrorMessage name="activites" class="text-danger" />
              </div>
               <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Langue <span class="text-danger">*</span>
                  </label>
                  <Field name="langues" v-slot="{ field }">
                    <Multiselect :options="languesOptions" :searchable="true" mode="tags" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner les langues" />
                  </Field>
                </div>
                <ErrorMessage name="langues" class="text-danger" />
              </div>
              <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Poste occupé actuellement
              </label>
              <Field name="poste" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le poste" />
              <ErrorMessage name="poste" class="text-danger" />
            </div>
          </div>
<div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Catégorie Profesionnelle
              </label>
              <Field name="categorie" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer la categorie" />
              <ErrorMessage name="categorie" class="text-danger" />
            </div>
          </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Informations complémentaires <span class="text-danger">*</span>
                  </label>
                  <Field name="biographie" rows="2" as="textarea" placeholder="Ajouter d'autres informations" v-slot="{ field }" class="form-control shadow-none rounded-0 text-black">
                    <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
                  </Field>
                  <ErrorMessage name="biographie" class="text-danger" />
                </div>
              </div>
              <div class="row">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                    <div class="row">
                      <div class="border border-primary mb-1">
                        <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                          style="background-color: #0a59a4">
                          <div class="col-md-7">
                            <h3 class="fs-4 text-white">Pièce(s)</h3>
                          </div>
                          <div class="col-md-5">
                            <div class="d-flex float-end">
                              <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                                type="button" :class="{ 'cursor-not-allowed': isDisable }" @click="addRowPiece()">
                                <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                                Ajouter une pièce
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <!-- Titres colonnes -->
                          <div class="row gx-1">
                            <div class="col-md-4">
                              <label class="d-block text-black fw-semibold">
                                Type de pièce <span class="text-danger">*</span>
                              </label>
                            </div>
                            <div class="col-md-4">
                              <label class="d-block text-black fw-semibold mb-1">
                                Numéro de pièce <span class="text-danger">*</span>
                              </label>
                            </div>
                            <div class="col-md-3">
                              <label class="d-block text-black fw-semibold mb-1">
                                Image <span class="text-danger">*</span>
                              </label>
                            </div>
                            <div class="col-md-1">
                              <label class="d-block text-black fw-semibold mb-1">
                                Action
                              </label>
                            </div>
                          </div>
                          <hr class="mt-0" />
                          <!-- Boucle sur les pièces -->
                          <div class="row gx-1" v-for="(piece, index) in pieces" :key="index">
                            <!-- Type de pièce -->
                            <div class="col-md-4 mb-3">
                              <div class="modern-select-group">
                                <Field :name="`pieces[${index}].typePiece`" v-slot="{ field }">
                                  <Multiselect v-model="pieces[index].typePiece" v-bind="field" :options="typeOptions"
                                    :preserve-search="true" :multiple="false" :searchable="true"
                                    placeholder="Sélectionner le type de pièce" label="label" track-by="value"
                                    class="modern-multiselect" />
                                </Field>
                                <ErrorMessage :name="`pieces[${index}].typePiece`" class="text-danger" />
                              </div>
                            </div>
                            <!-- Numéro de pièce -->
                            <div class="col-md-4 mb-3">
                              <div class="modern-input-group">
                                <Field type="text" class="form-control shadow-none fs-md-15 text-black modern-input"
                                  placeholder="Entrer le numéro de la pièce" :name="`pieces[${index}].numeroPiece`" v-model="pieces[index].numeroPiece" />

                                <ErrorMessage :name="`pieces[${index}].numeroPiece`" class="text-danger" />
                              </div>
                            </div>

                            <!-- Image -->
                            <div class="col-md-3 mb-3">
                              <div class="form-group mb-0">
                                <Field type="file" accept="image/*" class="form-control"
                                  @change="handleFileChange($event, index)" :name="`pieces[${index}].urlImage`" />

                                <ErrorMessage :name="`pieces[${index}].urlImage`" class="text-danger" />
                              </div>
                            </div>
                            <!-- Bouton suppression -->
                            <div class="col-md-1 mb-3" v-if="index > 0">
                              <button class="btn btn-danger transition border-0 py-1 px-2" type="button"
                                @click="removeRowPiece(index)">
                                <i class="flaticon-delete lh-1 me-0 position-relative top-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-3">
                <div class="d-flex align-items-center ">
                  <button ref="submitButton" class="btn btn-success me-3" type="submit" :disabled="isSubmitting">
                <i v-if="!isSubmitting" class="fa fa-plus me-2"></i>
                <i v-if="isSubmitting" class="fa fa-spinner fa-spin me-2"></i>
                {{ isSubmitting ? 'Enregistrement...' : 'Ajouter un professeur' }}
              </button>
                  <router-link to="/liste-professeurs" class=" btn btn-danger"><i
                      class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                    <span class="position-relative"></span>Annuler</router-link>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </template>

<script lang="ts">

import { defineComponent, ref, watch, reactive, onMounted } from 'vue';
import { Form, Field, ErrorMessage, useFieldArray, FormContext } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import { Professeur } from '@/models/Professeur';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import { VueTelInput } from 'vue3-tel-input'
import axios, { AxiosError } from 'axios';
import { countries } from "../../components/Inscription/countries";
import { Piece } from '@/models/Piece';

export default defineComponent({
  name: "AddProfesseur",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    VueTelInput
  },
  setup: () => {
    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const countriesRef = ref(countries);
    const typeOptions = ref([]);
    const professeurSchema = Yup.object().shape({
      nom: Yup.string()
        .required("Le nom du professeur est obligatoire"),
      prenom: Yup.string()
        .required("Le prénom du professeur est obligatoire"),
      sexe: Yup.string()
        .required("Le sexe est obligatoire"),
      qualification: Yup.string()
        .required("La qualification est obligatoire"),
      activites: Yup.array()
        .of(Yup.string().required())
        .min(1, 'Au moins un utilisateur est obligatoire'),
      npi: Yup.string()
        .matches(/^\d{10}$/, "La saisie doit avoir exactement 10 chiffres")
        .notRequired(),
      ifu: Yup.string()
        .matches(/^\d{13}$/, "La saisie doit avoir exactement 13 chiffres")
        .notRequired(),
      adresse: Yup.string().notRequired(),
      email: Yup.string().email("Veuillez entrer un mail valide").notRequired(),
      telProfesseur1: Yup.string().typeError('Veuillez entrer des chiffres').required('Le telProfesseur1 1 est obligatoire'),
      telProfesseur2: Yup.string().typeError('Veuillez entrer des chiffres').notRequired(),
      biographie: Yup.string().required("La biographie est obligatoire"),
       categorie: Yup.string()
        .notRequired(),
         poste: Yup.string()
        .notRequired(),
      matieres: Yup.array()
        .of(Yup.string().required())
        .min(1, 'Au moins une matière est obligatoire'),
        langues: Yup.array()
        .of(Yup.string().required())
        .min(1, 'Au moins une langue est obligatoire'),
      nationalite: Yup.string().required(
        "La nationalité est obligatoire"
      ),
      anneeExperience: Yup.number().notRequired(),
      //quartier: Yup.string().required('Le quartier est obligatoire'),
      pieces: Yup.array()
        .of(
          Yup.object().shape({
            typePiece: Yup.string().required('Le type de pièce est obligatoire'),
            numeroPiece: Yup.string().required('Le numéro de pièce est obligatoire'),
            urlImage: Yup.mixed().required("L'image est obligatoire"),
          })
        )
        .min(1, 'Au moins une pièce est requise'),
      dateNaissance: Yup.date()
        .notRequired()
        .max(new Date(), 'La date de naissance ne peut pas être dans le futur')
        .test(
          'age-minimum',
          'Le professeur doit avoir au moins 18 ans',
          function (value) {
            if (!value) return false;
            const today = new Date();
            const birthDate = new Date(value);
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            return age >= 18;
          }
        ),
      quartier: Yup.string().required("Le quartier est obligatoire"),
      commune: Yup.string().required("La commune est obligatoire"),


    });

    const isDisable = ref(true); // Désactiver par défaut
    const isSubmitting = ref(false);

    const nationalite = ref("Bénin");
    const professeurForm = ref<FormContext | null>(null);
    const router = useRouter();
    const defaultStatut = ref(1);
    //const showAdditionalFields = ref(true);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const matieresOptions = ref([]);
    const qualificationOptions = ref([]);
    const activiteOptions = ref([]);
    const languesOptions = ref([]);
    
    const arrondissement = ref();
    const quartier = ref();
    const commune = ref();
    const departement = ref();
    const departementOptions = ref([]);
    const communeOptions = ref([]);
    const arrondissementOptions = ref([]);
    const quartierOptions = ref([]);
    const codepay = ref();
    const nationalnumlber = ref();
    const telProfesseur1 = ref();
    const telProfesseur2 = ref();
    const validPhone = ref<boolean>(false);
    const numberPhone = ref();


    function validate(phoneObject) {
      validPhone.value = phoneObject.valid;
      if (phoneObject.valid == true) {
        telProfesseur1.value = phoneObject.number;
        telProfesseur2.value = phoneObject.number;
        codepay.value = phoneObject.countryCallingCode;
        nationalnumlber.value = phoneObject.nationalNumber;
        numberPhone.value = phoneObject.nationalNumber;

      } else {
        telProfesseur1.value = "";
        telProfesseur2.value = "";
        codepay.value = "";
        nationalnumlber.value = "";
        numberPhone.value = "";
      }
    }


    const selectedCommune = ref();
    const selectedQuartier = ref();

    // Charger les communes au départ
    const fetchCommunes = async () => {
      const { data } = await ApiService.get("/communes");
      communeOptions.value = data.data.data.map((item: any) => ({
        value: item.id,
        label: item.libelle,
      }));
    };

    // Charger les quartiers selon la commune choisie
    function communeChange(value) {
      if (value) {
        quartierOptions.value = [];
        selectedQuartier.value = null;
        ApiService.get("/communes/quartiers/" + value)
          .then(({ data }) => {
            const donnees = data.data;
            quartierOptions.value = donnees.map((quartier: any) => ({
              label: quartier.libelle,
              value: quartier.id,
            }));
          })
          .catch(({ response }) => {
            console.error(response.data.message);
          });
      } else {
        quartierOptions.value = [];
        selectedQuartier.value = null;
      }
    }

    onMounted(() => {
      fetchCommunes();
    });

    const fetchMatiere = async () => {
      try {
        const response = await axios.get('/all/matieres');
        const matieresData = response.data.data.data;
        matieresOptions.value = matieresData.map((matieres) => ({
          value: matieres.id,
          label: `${matieres.libelle}`,
        }));
      } catch (error) {
        //
      }
    };
 const fetchLangue = async () => {
      try {
        const response = await axios.get('/langues');
        const languesData = response.data.data.data;
        languesOptions.value = languesData.map((langues) => ({
          value: langues.id,
          label: `${langues.libelle}`,
        }));
      } catch (error) {
        //
      }
    };
    const fetchQualification = async () => {
      try {
        const response = await ApiService.get('/all/qualifications');
        const qualificationsData = response.data.data.data;
        qualificationOptions.value = qualificationsData.map((qualifications) => ({
          value: qualifications.id,
          label: `${qualifications.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchActivite = async () => {
      try {
        const response = await axios.get('/all/activites');
        const activitesData = response.data.data.data;
        activiteOptions.value = activitesData.map((activites) => ({
          value: activites.id,
          label: `${activites.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const getAllType = async () => {
      try {
        const response = await ApiService.get('/all/typePieces');
        typeOptions.value = response.data.data.data.map((type: any) => ({
          value: type.id.toString(),
          label: type.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des types de pièces:', error);
      }
    };

    const pieces = ref<Piece[]>([{ typePiece: '', numeroPiece: '', urlImage: null }]);
    const images = ref<Array<File>>([]);


    onMounted(() => {
      fetchMatiere();
      fetchLangue();
      fetchQualification();
      fetchActivite();
      getAllType();

    })


    const addRowPiece = async () => {
      // Valider le formulaire avant d'ajouter une nouvelle pièce
      const isValid = await professeurForm.value?.validate();
      console.log("isValid", isValid);
      if (!isValid?.valid) {
        error('Veuillez remplir tous les champs de la pièce actuelle avant d\'en ajouter une nouvelle.');
        return;
      }

      pieces.value.push({
        typePiece: '',
        numeroPiece: '',
        urlImage: null,
      });
      isDisable.value = true;
    };

    const removeRowPiece = (index: number) => {
      if (pieces.value.length > 1) {
        pieces.value.splice(index, 1);
      }
    };

    const handleFileChange = (event, index) => {
      const file = event.target.files[0];
      pieces.value[index].urlImage = file || null;
      console.log('Fichier sélectionné pour la pièce', index, ':', file);
    };

    watch(
      pieces,
      async (newValue) => {
        console.log('Pièces mises à jour:', newValue);
        if (newValue.length === 0) {
          isDisable.value = false;
          return;
        }
        const lastPiece = newValue[newValue.length - 1];
        // Valider la dernière pièce pour activer/désactiver le bouton
        const isValid = await professeurForm.value?.validate();
        isDisable.value = !isValid?.valid || !lastPiece.typePiece || !lastPiece.numeroPiece || !lastPiece.urlImage;
      },
      { deep: true }
    );

    const valuess = ref();
    const addProfesseur = async (values, { resetForm }) => {
      if (submitButton.value) {
        submitButton.value.disabled = true;
      }
      isSubmitting.value = true;
     
      try {
        const formData = new FormData();
        formData.append('nom', values.nom);
        formData.append('prenom', values.prenom);
        formData.append('sexe', values.sexe);
        formData.append('npi', values.npi);
        formData.append('ifu', values.ifu);
        formData.append('email', values.email);
        formData.append('telProfesseur1', telProfesseur1.value || values.telProfesseur1);
        formData.append('telProfesseur2', telProfesseur2.value || values.telProfesseur2 || '');
        formData.append('dateNaissance', values.dateNaissance);
        formData.append('nationalite', values.nationalite);
        formData.append('commune', values.commune);
        formData.append('quartier', values.quartier);
        formData.append('categorie', values.categorie);
    formData.append('biographie', values.biographie || '');

        formData.append('poste', values.poste);
        formData.append('anneeExperience', values.anneeExperience || '0');
        formData.append('qualification', values.qualification);
    
        if (values.matieres && values.matieres.length > 0) {
          formData.append('matieres',values.matieres);
        }
        
        if (values.activites && values.activites.length > 0) {
          formData.append('activites',values.activites);
        }

       if (values.langues && values.langues.length > 0) {
          formData.append('langues',values.langues);
        }
        // Handle pieces
        const piecesData = pieces.value.map(piece => ({
          typePiece: piece.typePiece,
          numeroPiece: piece.numeroPiece,
        }));
        formData.append('piecesData', JSON.stringify(piecesData));
        pieces.value.forEach((piece, index) => {
        if (piece.urlImage) {
          formData.append('piecesFichiers', piece.urlImage); 
          // formData.append('pieces', piece.urlImage); 
        }
      });

        console.log('Values (formulaire) :', values);
    console.log('Matières sélectionnées (brut) :', values.matieres);
    console.log('Matières envoyées (IDs) :', values.matieres);
    console.log('Pièces envoyées :', piecesData);
    console.log('Fichiers uploadés :', pieces.value.map(p => p.urlImage?.name).filter(Boolean));

        console.log('Payload envoyé à l\'API:', formData);

        const response = await ApiService.post('/professeurs', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.code === 201) {
          success(response.data.message);
          resetForm();
          router.push({ name: 'ListeProfesseurPage' });
        }
      } catch (err) {
        const axiosError = err as AxiosError<{ message?: string }>;
        console.error('Erreur lors de l\'enregistrement:', axiosError);
        error(axiosError.response?.data?.message || 'Une erreur est survenue.');
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      professeurSchema,
      addProfesseur,
      professeurForm,
      defaultStatut,
      submitButton, matieresOptions,
      valuess,
      qualificationOptions,
      activiteOptions,
      currentDate, nationalite,
      validPhone,
      countries: countriesRef,
      validate, quartierOptions,
      addRowPiece, pieces,
      removeRowPiece,
      handleFileChange,
      isDisable,
      typeOptions,
      communeOptions,
      commune,isSubmitting,
      quartier,
      departement,
      arrondissement,
      departementOptions,
      arrondissementOptions,
      languesOptions,
      communeChange,
      selectedCommune,
      selectedQuartier,
    };
  },
});
</script>
<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}
</style>
